export default __webpack_public_path__ + "static/media/van.01480dbd.png";